import { useMutation, useQueryClient } from '@tanstack/react-query';
import { schedulingApi } from '@/api';

const APPOINTMENTS_KEY = 'appointments';

export function useCancelAppointment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ appointmentId, reason }: { appointmentId: string; reason: string }) =>
      schedulingApi.cancelAppointment(appointmentId, reason),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [APPOINTMENTS_KEY] });
      queryClient.setQueryData(
        [APPOINTMENTS_KEY, 'appointment', data.id],
        (old: unknown) => ({
          ...(old as object),
          status: data.status,
          cancelledBy: data.cancelledBy,
          cancellationReason: data.cancellationReason,
          cancelledAt: data.cancelledAt,
        })
      );
    },
  });
}
